import React, { Component } from 'react';
import { connect } from "react-redux";
import { Redirect, Route, Switch } from 'react-router-dom';
import UserManage from '../containers/System/users/UserManage';
import ProductManage from '../containers/System/products/ProductManage';
import ClientManage from '../containers/System/clients/ClientManage';
import CountryManage from '../containers/System/countries/CountryManage';
import CategoryManage from '../containers/System/categories/CategoryManage';
import BannerManage from '../containers/System/banners/BannerManage';
import WarehouseManage from '../containers/System/warehouses/WarehouseManage';
import OrderManage from '../containers/System/orders/OrderManage';

class System extends Component {
    render() {
        const { systemMenuPath } = this.props;
        return (
            <div className="system-container">
                <div className="system-list">
                    <Switch>
                        <Route path="/system/staff-manage" component={UserManage} />
                        <Route path="/system/client-manage" component={ClientManage} />
                        <Route path="/system/product-manage" component={ProductManage} />
                        <Route path="/system/country-manage" component={CountryManage} />
                        <Route path="/system/category-manage" component={CategoryManage} />
                        <Route path="/system/banner-manage" component={BannerManage} />
                        <Route path="/system/warehouse-manage" component={WarehouseManage} />
                        <Route path="/system/order-manage" component={OrderManage} />
                        <Route component={() => { return (<Redirect to={systemMenuPath} />) }} />
                    </Switch>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        systemMenuPath: state.app.systemMenuPath
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(System);
